// Tall-formattering for selskapsinfo (nb-NO, tabular-nums i UI). Mockupen viser store
// beløp i MNOK ("13,5 MNOK") og mindre tall i hele kroner ("343 557", "−95 099").

const nf = new Intl.NumberFormat("nb-NO");
const nfMnok = new Intl.NumberFormat("nb-NO", { maximumFractionDigits: 2 });

/** Hele tall med tusenskille, "−" som minus-tegn (som mockupen). */
export function formatInt(n: number | null | undefined): string {
  if (n == null) return "—";
  return nf.format(n);
}

/** Adaptiv KPI-verdi: ≥ 1 MNOK vises som MNOK, ellers hele kroner.
 *  Returnerer { value, unit } så UI kan rendre enheten som <small> (mockup-stil). */
export function formatKpi(n: number | null | undefined): { value: string; unit: string | null } {
  if (n == null) return { value: "—", unit: null };
  if (Math.abs(n) >= 1_000_000) {
    return { value: nfMnok.format(n / 1_000_000), unit: "MNOK" };
  }
  return { value: nf.format(n), unit: null };
}

/** "13,5 MNOK" / "343 557" som én streng (rad-tabeller, noter). */
export function formatAmount(n: number | null | undefined): string {
  const { value, unit } = formatKpi(n);
  return unit ? `${value} ${unit}` : value;
}

/** Årstall fra ISO-dato ("2018-03-14" → "2018"). */
export function yearOf(iso: string | null | undefined): string | null {
  if (!iso) return null;
  return iso.slice(0, 4);
}
